"use client";

import { useInstallTarget, withUtm } from "../lib/install";

export default function Footer() {
  const install = useInstallTarget();

  const links = [
    { href: "/tools/instrumental-enhancer", label: "Instrumental Enhancer", title: "Open the free instrumental enhancer tool" },
    { href: "/tools/8d-audio-converter", label: "8D Audio Converter", title: "Open the free 8D audio converter tool" },
    { href: "/welcome", label: "Getting Started", title: "8Dfy getting started guide" },
    { href: "/welcome/pro", label: "Pro Setup", title: "8Dfy Pro setup guide" },
    {
      href: withUtm(install.baseUrl, "footer"),
      label: install.storeName,
      title: `Install 8Dfy from the ${install.storeName}`,
      external: true,
    },
    // On-page contact section (the mailto alias here didn't match the
    // monitored address in the Contact section)
    { href: "/#contact", label: "Contact", title: "Contact 8Dfy support" },
    { href: "/privacy", label: "Privacy", title: "Read the 8Dfy privacy policy" },
  ];

  return (
    <footer style={{ borderTop: "1px solid var(--border-subtle)" }} className="mt-16">
      <div className="max-w-[1200px] mx-auto px-6 py-10 flex flex-col sm:flex-row items-center justify-between gap-6">
        <div className="flex items-center gap-4">
          <span className="text-lg font-black tracking-tight bg-gradient-to-r from-[#FF3366] to-[#FF9F1C] bg-clip-text text-transparent">
            8Dfy
          </span>
          <span className="text-[11px] font-bold uppercase tracking-[1.4px] text-[#b3b3b3]/75">
            Spatial audio for everyone.
          </span>
        </div>

        <nav aria-label="Footer" className="flex flex-wrap items-center justify-center gap-x-6 gap-y-3">
          {links.map((l) => (
            <a
              key={l.label}
              href={l.href}
              title={l.title}
              {...(l.external ? { target: "_blank", rel: "noopener noreferrer" } : {})}
              className="inline-block py-2 text-[11px] font-bold uppercase tracking-[1.4px] text-[#b3b3b3] hover:text-white transition-colors duration-200"
            >
              {l.label}
            </a>
          ))}
          <span className="text-[11px] text-[#b3b3b3]/75">&copy; 2026 8Dfy</span>
        </nav>
      </div>
    </footer>
  );
}
